export default __webpack_public_path__ + "static/media/success.95c87a25.svg";